var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4736 0.0926879C10.6971 0.00328386 10.9464 0.0032836 11.1699 0.0926879L11.5137 0.229407L11.5186 0.23136L20.2324 3.71769C20.5883 3.86007 20.8223 4.20447 20.8223 4.58781V15.415C20.8221 15.7981 20.5882 16.1428 20.2324 16.2851L11.1699 19.9101C10.9465 19.9994 10.6971 19.9995 10.4736 19.9101L1.41113 16.2851C1.05535 16.1427 0.822442 15.7981 0.822266 15.415V4.58781C0.822266 4.20454 1.05533 3.86011 1.41113 3.71769L10.126 0.23136L10.1309 0.229407L10.4736 0.0926879ZM10.8223 7.45304L3.12988 4.37589L2.07227 4.79972V5.29972L10.1973 8.54972V18.453L10.8223 18.703L11.4473 18.453V8.54972L19.5723 5.29972V4.79972L18.5137 4.37589L10.8223 7.45304Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.803128e0d098bc4e6e35d72be78045e7.svg";
export { ForwardRef as ReactComponent };